import { CheckIcon } from "lucide-react";

const FLOW_STEPS = ["Trip details", "Route stops", "Templates", "Create trip"] as const;

/** Shows progress through the new-trip flow: trip details, route stops, templates, then the editable quote. */
const PortalFlowSteps = ({ current }: { current: 2 | 3 }) => (
  <ol
    className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs font-semibold text-gray-500"
    aria-label="Trip setup progress"
  >
    {FLOW_STEPS.map((label, index) => {
      const step = index + 1;
      const isDone = step < current;
      const isCurrent = step === current;
      return (
        <li key={label} className="flex items-center gap-2" aria-current={isCurrent ? "step" : undefined}>
          {index > 0 ? <span className="h-px w-5 bg-gray-300" aria-hidden="true" /> : null}
          <span
            className={`flex h-5 w-5 items-center justify-center rounded-full text-[11px] ${isCurrent ? "bg-(--brand-secondary) text-white" : isDone ? "bg-emerald-50 text-emerald-700" : "bg-gray-100 text-gray-500"}`}
          >
            {isDone ? <CheckIcon className="h-3 w-3" /> : step}
          </span>
          <span className={isCurrent ? "text-[#131B2A]" : undefined}>{label}</span>
        </li>
      );
    })}
  </ol>
);

export default PortalFlowSteps;
